import React from 'react';
import { Box, makeStyles, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';


const useStylesSegment = makeStyles({
  container: {
    width: '100%',
    height: 10,
    backgroundColor: '#eee',
    borderRadius: 5,
    display: 'flex',
    overflow: 'hidden',
  },
  segment: {
    height: '100%',
    transition: 'width 0.4s ease',
  },
});

const DiscreteProgressBar = ({ segments }) => {
  const classes = useStylesSegment();
  return (
    <Box className={classes.container}>
      {segments.map((seg, idx) => (
        <Tooltip key={idx} title={`${seg.value}%`} arrow>
          <Box
            className={classes.segment}
            style={{
              width: `${seg.value}%`,
              backgroundColor: seg.color,
            }}
          />
        </Tooltip>
      ))}
    </Box>
  );
};

DiscreteProgressBar.propTypes = {
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
  ).isRequired,
};


export { DiscreteProgressBar };
